import http from "../http-common";

class EtapaService {

    create(data) {
        return http.post("/etapa",data);
    }

    getAll() {
        return http.get("/etapa");
    }

    getByIdTrabajador(id_trabajador) {
        return http.get(`/etapa/bytrabajador/${id_trabajador}`);
    }

    updateEtapa(id, data) {
        return http.put(`/etapa/${id}`,data);
    }

    deleteEtapa(id) {
        return http.delete(`/etapa/${id}`);
    }

    updateProceso(nombre_etapa, trabajador_id, data) {
        return http.put(`/etapa/${nombre_etapa}/${trabajador_id}`, data);
    }
}

export default new EtapaService();